<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/insbillcheck/getlist"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="detail(row)"
            >详情</el-button
          >
          <el-button type="text" size="mini" @click="audit(row)"
            >审核</el-button
          >
        </template>
      </BaseTable>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="30%"
        @close="dialogClosed"
      >
        <BaseForm
          ref="baseForm"
          v-model="formData"
          :formOptions="cashFormOption"
          :rules="rules"
        ></BaseForm>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="handleSubmit"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";
import { cashFormOption } from "./formOptions";
import { rules } from "./rules";

export default {
  name: "Audit",
  comments: {},
  data() {
    return {
      searchData: {},
      tableData: [],
      orgOption: [],
      // 弹框相关
      dialogTitle: "",
      dialogVisible: false,
      // 表单相关
      formData: {},
      rules: rules(this),
    };
  },
  computed: {
    columns,
    searchFormOption,
    cashFormOption,
  },
  created() {
    //console.log(this.columns);
  },
  methods: {
    audit(row) {
      this.dialogTitle = `统筹单审核(${row.insBillId})`;
      this.dialogVisible = true;
      this.formData = {
        ...this.formData,
        ...row,
        is_pass: 1,
      };
    },

    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
    // 点击详情
    detail(row) {
      this.$router.push({
        path: "/issue/detail",
        query: {
          insBillId: row.insBillId,
        },
      });
    },
    // 提交
    handleSubmit() {
      this.$refs.baseForm.onSubmit((validate) => {
        if (validate) {
          this.$confirm("是否确认提交, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              await this.$api.post(
                "/admin/insbillcheck/submit",
                { ...this.formData },
                "审核"
              );
              this.dialogVisible = false;
              this.handleSearch();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });
        }
      });
    },
    // 弹框关闭
    dialogClosed() {
      this.formData = {};
      this.$refs.baseForm.resetFields();
    },
  },
};
</script>